import jobs from './jobs'
import offices from './offices'

export default { jobs, offices }
